import React from 'react';
import { toast } from 'react-toastify';

import { Bloc } from '@mairistem/administres-utils';
import { request } from '@mairistem/tools';
import { BlocTile } from '@/components/Common';
import useEntiteStore from '@/zustand/useEntiteStore';
import COLORS from '@/constants/colors';

import Divider from '@/components/Common/Divider';
import PacsModal from '../Modals/PacsModal';

interface BlocSynthetiqueProps {
  style?: React.CSSProperties;
  setLoading: (loading: boolean) => void;
}

const BlocSynthetique = (props: BlocSynthetiqueProps) => {
  const { style, setLoading } = props;

  const [statsSynthese, setStatsSynthese] = React.useState<any>(null);
  const [openModal, setOpenModal] = React.useState(false);
  const blocked = useEntiteStore((state) => state.blocked);

  React.useEffect(() => {
    if (!blocked) {
      setLoading(true);
      request
        .get('/api/administres/etat-civil/pacs/synthese')
        .then((data) => {
          setStatsSynthese(data);
        })
        .catch(() => {
          toast.error(
            'Une erreur est survenue lors de la récupération de la synthèse',
          );
        })
        .finally(() => setLoading(false));
    }
  }, [blocked, setLoading]);

  return (
    <Bloc
      icon="file text"
      header={
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <div>Vue synthétique</div>
        </div>
      }
      style={style}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          gap: '1em',
          marginTop: '1.5em',
        }}
      >
        <BlocTile
          title="Projet de PACS"
          data-testid="bloc-synthetique-projet"
          stats={statsSynthese ? statsSynthese.nbProjet : '0'}
          statsColor={COLORS.LightBlueCardColor}
          onClick={() => setOpenModal(true)}
        />
        <Divider vertical style={{ height: '120%', marginTop: '0em' }} />
        <BlocTile
          title="PACS en cours"
          data-testid="bloc-synthetique-en-cours"
          stats={statsSynthese ? statsSynthese.nbEnCours : '0'}
          statsColor={COLORS.GreenCardColor}
        />
        <BlocTile
          title="PACS dissous"
          data-testid="bloc-synthetique-dissous"
          stats={statsSynthese ? statsSynthese.nbDissous : '0'}
          statsColor={COLORS.RedCardColor}
        />
        <BlocTile
          title="PACS irrecevable"
          data-testid="bloc-synthetique-irrecevable"
          stats={statsSynthese ? statsSynthese.nbIrrecevable : '0'}
          statsColor={COLORS.PurpleCardColor}
        />
      </div>
      <PacsModal
        open={openModal}
        typePacs="Projet"
        title="Liste des projets de PACS"
        onClose={() => setOpenModal(false)}
        stats
      />
    </Bloc>
  );
};

export default BlocSynthetique;
